document.querySelectorAll('.remove-item').forEach(function (button) {
  button.addEventListener('click', function (event) {
    event.preventDefault();
    const variantId = this.getAttribute('data-variant-id');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 0,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        // Refresh the page to ensure the cart is updated and the item is removed
        location.reload();
      })
      .catch((error) => console.error('Error:', error));
  });
});

/*$(document)
  .on('focus', '#datepicker', function () {
    $('.delivery-date-label-for').hide();
  })
  .on('blur', '#datepicker', function () {
    if ($(this).val() === '') {
      $('.delivery-date-label-for').show();
    }
  });*/

document.addEventListener('DOMContentLoaded', function (event) {
  let applyBtn = document.querySelector('#apply-discount-btn');
  let discountCodeError = document.querySelector('#discount-code-error');
  let discountCodeWrapper = document.querySelector('#applied-discount-code .applied-discount-code-wrapper');
  let discountCodeName = document.querySelector('.applied-discount-code-name');
  let discountCodeValue = document.querySelector('.applied-discount-code-value');
  let discountCodeInput = document.querySelector('#discount-code-input');
  let subtotalElement = document.querySelector('#cart-subtotal-discount-value');
  let authorization_token;

  const commentsField = document.querySelector('#additional-comments');
  const COMMENTS_KEY = 'Additional comments';

  function saveCommentsToCart(value) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          [COMMENTS_KEY]: value || '',
        },
      }),
    }).then((res) => res.json());
  }

  if (commentsField) {
    let timeout = null;

    commentsField.addEventListener('input', function () {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        saveCommentsToCart(commentsField.value);
      }, 400);
    });
  }

  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      if (commentsField && cart.attributes && cart.attributes[COMMENTS_KEY]) {
        commentsField.value = cart.attributes[COMMENTS_KEY];
      }
    })
    .catch(() => {});

  const hearSelect = document.querySelector('#hear-about-us');
  const HEAR_KEY = 'How did you hear about us?';

  function saveHearToCart(value) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          [HEAR_KEY]: value || '',
        },
      }),
    }).then((res) => res.json());
  }

  if (hearSelect) {
    hearSelect.addEventListener('change', function () {
      saveHearToCart(hearSelect.value);
    });
  }

  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      if (hearSelect && cart.attributes && cart.attributes[HEAR_KEY]) {
        hearSelect.value = cart.attributes[HEAR_KEY];
      }
    })
    .catch(() => {});

  function updateSubtotal() {
    fetch('/cart.js')
      .then((res) => res.json())
      .then((data) => {
        if (subtotalElement) {
          subtotalElement.innerHTML =
            '€' +
            parseFloat(data.total_price / 100)
              .toFixed(2)
              .replace('.', ',');
        }
      })
      .catch((error) => console.error('Erro ao obter o subtotal:', error));
  }

  updateSubtotal();

  if (applyBtn) {
    applyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      applyDiscount(discountCodeInput.value);
    });
  }

  if (discountCodeInput) {
    discountCodeInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        applyDiscount(discountCodeInput.value);
      }
    });
  }

  function applyDiscount(code) {
    if (!code) return;

    if (applyBtn) {
      applyBtn.innerHTML = "Adding <div class='loader'></div>";
      applyBtn.style.pointerEvents = 'none';
    }

    localStorage.setItem('discountCode', JSON.stringify({ code: code.trim() }));

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { discount_code: code.trim() },
      }),
    })
      .then((res) => res.json())
      .then(() => {
        window.location.href = `/discount/${encodeURIComponent(code.trim())}?redirect=/cart`;
      })
      .catch((error) => {
        console.error('Erro ao aplicar o desconto:', error);
        const lang = document.documentElement.lang;
        if (discountCodeError) {
          discountCodeError.innerHTML =
            lang === 'nl'
              ? 'Er is een fout opgetreden bij het toepassen van de korting.'
              : 'An error occurred while applying the discount.';
        }
      })
      .finally(() => {
        if (applyBtn) {
          applyBtn.innerHTML = 'Add';
          applyBtn.style.pointerEvents = 'all';
        }
      });
  }

  function resetDiscountDisplay() {
    if (discountCodeName) discountCodeName.innerHTML = '';
    if (discountCodeValue) discountCodeValue.innerHTML = '';
    if (discountCodeError) discountCodeError.innerHTML = 'Please enter a valid coupon code.';
    if (discountCodeWrapper) discountCodeWrapper.style.display = 'none';
    localStorage.removeItem('discountCode');
  }

  fetch('/cart.js')
    .then((response) => response.json())
    .then((data) => {
      if (data.attributes && data.attributes.discount_code) {
        discountCodeInput.value = data.attributes.discount_code;
        if (discountCodeWrapper) discountCodeWrapper.style.display = 'flex';
        if (discountCodeWrapper) discountCodeWrapper.style.margin = '24px 0 0 0';
        if (discountCodeName) discountCodeName.innerHTML = data.attributes.discount_code;
        if (discountCodeValue) discountCodeValue.innerHTML = 'Applied!';
      }
    })
    .catch((error) => console.error('Error retrieving discount:', error));

  const checkoutButton = document.querySelector("button[name='checkout']");
  if (checkoutButton) {
    checkoutButton.addEventListener('click', async function (e) {
      e.preventDefault();

      if (commentsField) {
        try {
          await saveCommentsToCart(commentsField.value);
        } catch (err) {
          console.warn('Failed to save comments before checkout', err);
        }
      }

      if (hearSelect) {
        try {
          await saveHearToCart(hearSelect.value);
        } catch (err) {
          console.warn('Failed to save hear about us before checkout', err);
        }
      }

      fetch('/cart.js')
        .then((response) => response.json())
        .then((data) => {
          let checkoutUrl = new URL('/checkout', window.location.origin);

          if (data.attributes && data.attributes.discount_code) {
            checkoutUrl.searchParams.set('discount', data.attributes.discount_code);
          }

          window.location.href = checkoutUrl.toString();
        })
        .catch((error) => {
          console.error('Erro ao recuperar cupom para checkout:', error);
          checkoutButton.form?.submit();
        });
    });
  }
});

/*document.addEventListener('DOMContentLoaded', function () {
  var selectedDate = localStorage.getItem('selectedDeliveryDate');

  if (selectedDate) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          'Delivery Date': selectedDate,
        },
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Data de entrega adicionada ao carrinho:', data);
      })
      .catch((error) => console.error('Erro ao atualizar o carrinho:', error));
  }
});*/

/*function updateLabelText() {
  const lang = document.documentElement.lang;
  const label = document.querySelector('.delivery-date-label-for');

  if (label) {
    const newText = lang === 'nl' ? 'Kies bezorgdag' : 'Choose delivery day';

    if (label.textContent !== newText) {
      label.textContent = newText;
    }
  }
}

document.addEventListener('DOMContentLoaded', updateLabelText);

const targetNode = document.getElementById('st_delivery');
if (targetNode) {
  const observer = new MutationObserver((mutations, obs) => {
    obs.disconnect();

    setTimeout(() => {
      updateLabelText();
      obs.observe(targetNode, { childList: true, subtree: true });
    }, 100);
  });

  observer.observe(targetNode, { childList: true, subtree: true });
}

document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.checkout-button button');

  buttons.forEach((button) => {
    const parent = button.parentElement;
    const tooltipText = parent.getAttribute('data-title');

    let tooltip = parent.querySelector('.tooltip-message');
    if (!tooltip) {
      tooltip = document.createElement('div');
      tooltip.classList.add('tooltip-message');
      tooltip.textContent = tooltipText;
      parent.appendChild(tooltip);
    }

    const isDisabled = Math.random() > 0.5;
    button.disabled = isDisabled;

    button.addEventListener('mouseover', function () {
      if (button.disabled) {
        tooltip.style.display = 'block';
      }
    });

    button.addEventListener('mouseout', function () {
      tooltip.style.display = 'none';
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  let checkExist = setInterval(function () {
    let element = document.getElementById('streamthing_DOM_insertion_point_v2');
    let target = document.getElementById('deliverypick');

    if (element && target) {
      target.appendChild(element);
      clearInterval(checkExist);
    }
  }, 300);
});
*/

(function () {
  try {
    var isEN = location.pathname.indexOf('/en') === 0 || document.documentElement.lang === 'en';
    if (!isEN) return;

    var TEXTS = {
      shippingPlaceholder: 'Choose delivery day',
      requiredError: 'Select a date',
    };

    function applyTexts() {
      var shippingPicker = document.querySelector('#csShippingpicker');
      if (shippingPicker) {
        shippingPicker.placeholder = TEXTS.shippingPlaceholder;
        shippingPicker.setAttribute('placeholder', TEXTS.shippingPlaceholder);
      }

      var requiredError = document.querySelector('#required-error #postal-code-error');
      if (requiredError) {
        requiredError.textContent = TEXTS.requiredError;
      }
    }

    var tries = 0;
    var maxTries = 80;
    var timer = setInterval(function () {
      tries++;

      var appRoot = document.querySelector('#csShippingAppCode');
      if (appRoot) {
        applyTexts();

        if (window.MutationObserver) {
          var scheduled = false;
          var obs = new MutationObserver(function () {
            if (scheduled) return;
            scheduled = true;
            requestAnimationFrame(function () {
              scheduled = false;
              applyTexts();
            });
          });

          obs.observe(appRoot, { childList: true, subtree: true });
        }

        clearInterval(timer);
      }

      if (tries >= maxTries) clearInterval(timer);
    }, 250);

    window.addEventListener('load', function () {
      applyTexts();
    });
  } catch (e) {
    console.warn('[Cart text override] failed:', e);
  }
})();
